import React, { useState } from 'react';
import axios from 'axios';

const API_URL = '/api';

function LoginPage({ setToken, setUser }) {
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);

  const handleLogin = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError('');
    
    try {
      const response = await axios.post(`${API_URL}/auth/login`, {
        username,
        password
      });
      setToken(response.data.token);
      setUser(response.data.user);
      localStorage.setItem('token', response.data.token);
      localStorage.setItem('userId', response.data.user._id);
    } catch (err) {
      setError(err.response?.data?.error || 'Giriş başarısız');
    } finally {
      setLoading(false);
    }
  };

  return (
    <>
      <div className="data-flow">
        {[...Array(10)].map((_, i) => <div key={`v${i}`} className="data-line"></div>)}
        {[...Array(5)].map((_, i) => <div key={`h${i}`} className="data-line-horizontal"></div>)}
      </div>

      <div className="header-section">
        <div className="tech-cloud">
          <svg className="cloud-icon" viewBox="0 0 100 60" xmlns="http://www.w3.org/2000/svg">
            <defs>
              <linearGradient id="cloudGradient2" x1="0%" y1="0%" x2="100%" y2="100%">
                <stop offset="0%" style={{stopColor:'#dc2626',stopOpacity:1}} />
                <stop offset="100%" style={{stopColor:'#ff4444',stopOpacity:1}} />
              </linearGradient>
            </defs>
            <path d="M 20,45 Q 10,45 10,35 Q 10,25 20,25 Q 20,15 30,15 Q 40,15 40,25 Q 50,10 65,10 Q 80,10 80,25 Q 90,25 90,35 Q 90,45 80,45 Z" 
                  fill="url(#cloudGradient2)" opacity="0.9"/>
          </svg>
          <h1 className="cloud-title">CLOUD CONTROL</h1>
        </div>
      </div>

      <div className="login-container">
        <div className="login-box">
          <div className="logo-container">
            <img src="/logo.png" alt="MiM Bytes" className="logo-img" />
          </div>
          
          {error && <div className="error">{error}</div>}
          
          <form onSubmit={handleLogin}>
            <div className="form-group">
              <label>KULLANICI ADI</label>
              <input
                type="text"
                value={username}
                onChange={(e) => setUsername(e.target.value)}
                required
                autoFocus
              />
            </div>
            <div className="form-group">
              <label>ŞİFRE</label>
              <input
                type="password"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                required
              />
            </div>
            <button type="submit" disabled={loading}>
              {loading ? 'GİRİŞ YAPILIYOR...' : 'GİRİŞ YAP'}
            </button>
          </form>

          <div className="server-status">
            <span className="dot"></span>
            Server Active | MiM Bytes IoT Platform
          </div>
        </div>
      </div>
    </>
  );
}

export default LoginPage;
